import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";

const ViewDiscount = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main_title">
        <h1>Discount & Coupon Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/discount-coupon")}> Discount & Coupon Management</button> -
          View Discount & Coupon Management
        </p>
      </div>

      <div className="cards">
        <div className="view_page">
          <div className="gap_p">

            <div className="w_33">
              <h6>Offer/Discount Name</h6>
              <p>Festival Special Discount</p>
            </div>

            <div className="w_33">
              <h6>Coupon Code</h6>
              <p>
                <span className="status_btn c_success">FESTAUG25</span>
              </p>
            </div>

            <div className="w_33">
              <h6>Discount Type</h6>
              <p>Percentage</p>
            </div>

            <div className="w_33">
              <h6>Discount Value</h6>
              <p>5%</p>
            </div>

            <div className="w_33">
              <h6>Valid From – To</h6>
              <p>25 August 2025 – 30 August 2025</p>
            </div>

            <div className="w_33">
              <h6>Created Date</h6>
              <p>30 July 2025</p>
            </div>

            <div className="w_33">
              <h6>Status</h6>
              <p><SwitchToggle /></p>
            </div>

            <div className="w_100">
              <h6>Applicable Services / Categories</h6>
              <ul className="inline_tags">
                <li>Service 1</li>
                <li>Category 2</li>
                <li>Service 2</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDiscount;
